export default __webpack_public_path__ + "static/media/bannerhome-6.91ac9df6.png";